<template>
  <!-- 关键词列表 -->
  <div>
    <div
      class="OptimizeTop"
      :class="{active: !isShowItem}"
    >
      <div class="OptimizeTitle">{{isShowHeader ? '文章列表' : keywordname}}</div>
      <filter-panel
        :data="groups"
        @search="filterChange"
        @change="change"
        v-if="!isFilter"
        hideResult
        hideBorder
      ></filter-panel>
    </div>

    <!-- 列表 -->
    <data-list
      :data="data"
      :columns="column"
      :page="page"
      :selection='selection'
      :page-size="page.pageSize"
      :tableStyle="{name: 'mixture'}"
      :isShowHeader="isShowHeader"
      :loading="loading"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
  </div>
</template>

<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel.vue";
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";

const list = listPageCreate({
  searchConfig: {
    api: api.seo.seoarticlelist,
    method: "POST",
    config: {
      timeout: 30000
    }
  },
  getQuery(obj, that) {
    return _.assign(obj, { keyId: that.keywordID });
  }
});

export default {
  mixins: [list],
  props: {
    column: Array,
    groups: Object,
    isShowItem: Boolean,
    isShowBtn: Boolean,
    selection: Boolean,
    isShowHeader: Boolean,
    isFilter: Boolean
  },
  data() {
    return {
      seoSiteId: "",
      keywordstati: "",
      keywordID: "",
      keywordname: "文章列表"
    };
  },
  methods: {
    change(item, value) {},
  },
  components: { filterPanel }
};
</script>

<style scoped lang='scss'>
.add {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .button {
    margin-left: 30px;
  }
}
.OptimizeTop {
  padding: 25px 30px 0px;
  .OptimizeTitle {
    font-size: 14px;
    font-weight: 700;
    color: #333;
  }
}
.OptimizeTop.active {
  margin-bottom: 12px;
}
</style>
